import { useCallback, useState } from 'react';


const useSwiperTabs = (init: number = 0) => {
    const [swiper, setSwiper] = useState<{slideTo: (v: number) => void} | null>(null);
    const [index, _setIndex] = useState(init);

    const setIndex = useCallback((idx: number, fromSwiper: boolean = false) => {
        if (!fromSwiper)
            swiper?.slideTo(idx);

        _setIndex(idx);
    }, [swiper]);

    return {
        index,
        setSwiper,
        setIndex,
    }
};

export default useSwiperTabs;
